/* eslint-disable max-lines */
/* eslint-disable complexity */
import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Col, Form, Row, Spin, Popover, Icon, Modal, Select } from "antd";
import { connect, useDispatch, useSelector } from "react-redux";
import { withSize } from "react-sizeme";
import { api, checkEmptyArray } from "../../services";
import history from "../../history";
import config from "appConfig";
import styles from "./styles/UserProfilePage.scss";
import {
  DateSelector,
  DropdownSelect,
  InputText,
  MultiLevelSelector,
  PhotoUploader
} from "../../components/FormControls";
import { submitFormData } from "../../HOCs";
import { InputType } from "../../models";
import { DataSource, emptyUUID, HashTag, HrCountryId, PageRoute, UserRole } from "../../models/enums";
import {
  selectUser,
  selectBlockReasons,
  getUserProfileById,
  getUserStatistics,
  sendActivationEmail,
  activateXMLSyncNotifications,
  blockUser,
  unblockUser,
  getBlockReasons,
  triggerShadowBlock,
  deleteUser,
  autoRenewal,
} from "../../routes/Admin/ManageUserPage/user.ducks";
import { ReasonPickerModal } from "../../routes/Admin/ReasonPickerModal";
import { requireUserLogin } from "../../routes/Auth/HOCs";
import {
  getUserProfile,
  updateUserProfile
} from "../../routes/Auth/auth.ducks";
import { isObject } from "../../services/utils";
import UserStatistic from "./UserStatistic";
import PhoneNumbers from "../../components/PhoneNumbers"
import VerifyModal from "../../components/VerifyModal";
import appStyles from "../App/app.scss";
import LeftMenu from "../../components/LeftMenu";
import SinglePhoto from "../../components/FormControls/PhotoUploader/SinglePhoto";
//import GoogleAds from "../../components/GoogleAd";
import HelmetComponent from "../../utils/HelmetHelper";
import { UserI } from "../../typings/interfaces";
import { Loading } from "../../components/Loading";
import { selectCountries } from "../../routes/Configuration/configuration.ducks";
import { useCountries } from "../../routes/Configuration/hooks";
import { AdminNotes } from "../../routes/Admin/AdminNotes";
import confirmModal from "../../services/confirmModal";
import { StaticHTML } from "../../components";
import { FormInputText } from "./FormInputText";
import DominantCategoriesModal from "../../components/DominantCategoriesModal";
import { Button } from "../../components/Button/Button";


interface UserProfilePageProps {
  form: any;
  size: {
    width: number | null;
    height: number | null;
    position: any;
  };
  loading: boolean;
  history: History;
  location: Location;
  match: {
    path: string;
    url: string;
    isExact: boolean;
    params: any;
  };
  user: UserI;
  userProfile: UserI;
  settings: typeof defaultSettings;
  isAdminRoute: false;
  getUserProfile: (
    user: UserI,
    callback: () => void | boolean,
    shouldFetch: boolean
  ) => void;
  getUserProfileById: (id: string) => any;
  getUserStatistics: (id: string) => void;
  onSubmit: ({ }, callback: () => void) => void;
  sendActivationEmail: (id: string) => void;
  activateXMLSyncNotifications: (id: string, activateXmlSync: boolean, callback: (success: boolean) => void) => void;
  blockUser: (id: string, blockReasonId: number, note: string, basedOn: number, usersData: any, callback: (success: boolean) => void) => void;
  unblockUser: (id: string) => void;
  getBlockReasons: () => void;
  blockReasons: { id: number; name: string }[];
  triggerShadowBlock: (id: string, isBanned: boolean, callback: (success: boolean) => void) => void;
  deleteUser: (id: string) => void;
  autoRenewal: (autoRenewal: boolean, id: string, callback: (success: boolean) => void) => void;
  countries: any;
}

const defaultSettings = {
  formValidation: {
    oibPattern: /^\d{11}$/,
    emailMaxLength: 254,
    firstNameMaxLength: 20,
    lastNameMaxLength: 20,
    houseMaxLength: 50,
    streetMaxLength: 50,
    placeMaxLength: 100,
    descriptionMaxLength: 2000
  },
  responsiveProps: {
    columnSpace: { xs: 10, sm: 20, md: 50, lg: 96, xl: 96 },
    columnSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 }
  },
  location: {
    dataSource: DataSource.location,
    isMultiRows: true,
    isRequired: true,
    child: {
      title: "Država",
      field: "countryId",
      placeholder: "Država",
      child: {
        title: "Županija",
        field: "countyId",
        placeholder: "Županija",
        child: {
          title: "Grad",
          field: "cityId",
          placeholder: "Grad",
          child: {
            title: "Naselje",
            field: "settlementId",
            placeholder: "Naselje"
          }
        }
      }
    }
  },

  placeholder: {
    username: "Korisničko ime",
    email: "E-mail adresa",
    firstName: "Ime",
    lastName: "Prezime",
    dateOfBirth: "Datum rođenja",
    zipCode: "Poštanski broj ",
    street: "Ulica",
    houseNumber: "Kućni broj",
    identityNumber: "OIB",
    vatCountry: "Odaberite dražavu",
    vatIdentityNumber: "VAT ID",
    legalEntityIdentifier: "OIB",
    description: "Napišite nešto",
    place: "Mjesto",
    legalEntityName: "Naziv pravnog subjekta",
    websiteUrl: "Web",
    facebookUrl: "Facebook",
    instagramUrl: "Instagram",
  }
};
let errors: any = {};

const UserProfilePage = (props: UserProfilePageProps) => {
  const {
    isAdminRoute,
    match: { path },
    size: { width },
    form,
    countries,
    userProfile
  } = props;

  // Countries of the VAT invoice select (configuration/countries)
  useCountries();

  const [isLoading, setIsLoading] = useState(true);
  const [isChecked, setIsChecked] = useState(null);
  const [isReceipt, setIsReceiptChecked] = useState(false);
  const [isObligor, setIsObligor] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [adminNotesModalVisible, setAdminNotesModalVisible] = useState(false);
  const [suggestedUsernames, setSuggestedUsernames] = useState([]);
  const [suggestedUsername, setSuggestedUsername] = useState("");
  const [showPhoneVerifyModal, setShowPhoneVerifyModal] = useState(false);
  const [pendingBlock, setPendingBlock] = useState(null);
  const [blockModalLoading, setBlockModalLoading] = useState(false);
  const phoneNumbersRef = useRef(null);

  const isIdentityNumberRequired = isAdminRoute
    ? form.getFieldValue("isIdentityNumberRequiredOverride")
    : userProfile.isIdentityNumberRequired;

  const [isValidating, setIsValidating] = useState(false);
  const today = new Date();

  const locationValidator = {
    validator: (rule, value, callback) => {
      if (!value || !value.countryId || value.countryId === emptyUUID) {
        return callback("Odaberite sve razine");
      }

      if (
        value.countryId === HrCountryId && (
          (!value.countyId || value.countyId === emptyUUID) ||
          (!value.cityId || value.cityId === emptyUUID) ||
          (!value.settlementId || value.settlementId === emptyUUID)
        )) {

        return callback("Odaberite sve razine");
      }

      callback(errors[rule.field]);
    }
  };

  useEffect(() => {
    setIsDirty(props.form.isFieldsTouched());
  }, [props.form.isFieldsTouched()]);

  // Unsaved changes confirmation modal
  const showUnsavedChangesModal = (location) => {
    confirmModal.show({
      title: "Jeste li sigurni da želite napustiti ovu stranicu?",
      okText: "Napusti bez spremanja",
      cancelText: "Odustani",
      onCancel: () => {
        return
      },
      onOk: () => {
        history.block(() => { }); // Unblock 
        history.push(location.pathname); // Proceed with navigation
      },
      children: (
        <React.Fragment>
          <p>{"Niste snimili promjene. Ako sada napustite stranicu, svi uneseni podaci bit će izgubljeni. Želite li nastaviti?"}</p>
        </React.Fragment>
      ),
    });

  };

  useEffect(() => {
    let unblock = null;


    // Check if the form is dirty and not submitting and then block routing until user confirms
    if (isDirty && !isValidating) {
      unblock = history.block((location) => {
        showUnsavedChangesModal(location);
        return false; // Block navigation until user confirms
      });
    }

    return () => {
      if (unblock) {
        unblock();
      }
    };

  }, [isDirty, isValidating]);

  const setUserStats = (userProfile: UserI) => {
    if (userProfile) {
      setIsChecked(userProfile.legalEntity);
      setIsReceiptChecked(userProfile.legalEntity && userProfile.isUsingVATInvoice);
      setIsObligor(userProfile.isUsingVATInvoice && userProfile.isPublicProcurement);
    }
  }

  useEffect(() => {
    if (isAdminRoute) {
      const {
        match: {
          params: { id }
        }
      } = props;

      if (id) {
        props.getUserProfileById(id).then(() => {
          setIsLoading(false);
          props.getUserStatistics(id);
        });
      }

      if (!props.blockReasons || !props.blockReasons.length) {
        props.getBlockReasons();
      }
    }
  }, []);

  useEffect(() => {
    setUserStats(userProfile);
  }, [JSON.stringify(userProfile)]);

  useEffect(() => {
    if (!userProfile) return;
    const focusPhone = window.location.hash === HashTag.focusPhone;
    if (focusPhone) {
      setTimeout(() => {
        const phoneSection = document.querySelector(`.${styles.phonesContainer}`);
        if (phoneSection) {
          phoneSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        setTimeout(() => {
          if (phoneNumbersRef.current) {
            phoneNumbersRef.current.addAndFocusNewPhone();
          }
        }, 500);
      }, 300);
      history.replace(PageRoute.profile);
    }
  }, [userProfile]);

  const handleSubmit = event => {
    const { form, onSubmit, userProfile, isAdminRoute } = props;
    event.preventDefault();

    setIsValidating(true);
    form.validateFields((error, values) => {
      if (!error || isAdminRoute) {
        let submitData: any = {};
        isObject(values) &&
          // eslint-disable-next-line complexity
          Object.keys(values).forEach(key => {
            const value = values[key];
            if (key === "avatar") {
              if (value && value[key] && value[key].length > 0) {
                submitData = { ...submitData, avatar: value[key][0] };
              }
            } else if (key === "legalEntity" ||
              key === "isUsingVATInvoice" ||
              key === "isPublicProcurement" ||
              key === "isIdentityNumberRequiredOverride") {
              submitData = {
                ...submitData,
                [key]: value || false
              };
            } else if (value) {
              submitData = { ...submitData, ...value };
            }
          });

        if (userProfile) {
          // Add isVerified to use in auth.duck check refresh token
          submitData.isVerified = userProfile.isVerified;
        }

        if (isAdminRoute) {
          submitData.userId = userProfile.userId;
          submitData.isIdentityNumberRequired = submitData.isIdentityNumberRequiredOverride;
        }

        if (!isAdminRoute && !userProfile.hasVerifiedPhoneNumber) {
          submitData.skipNotification = true;
        }

        onSubmit(submitData, (status) => {
          if (status && !isAdminRoute) {
            getUserData((updatedUser) => {
              if (updatedUser && !updatedUser.hasVerifiedPhoneNumber) {
                setShowPhoneVerifyModal(true);
              }
            });
          } else {
            getUserData();
          }
        });

        setIsValidating(false);
        setIsDirty(false);
      }

      //scroll to error fields only if it's not an admin route
      if (!isAdminRoute) {
        setTimeout(() => {
          const formItemControlWithError = document.getElementsByClassName("ant-form-item-control has-error");
          if (formItemControlWithError && formItemControlWithError.length > 0) {
            formItemControlWithError[0].scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
          }
        }, 500);
      }
    });
  };

  const handleAutoRenewalClick = (userProfile) => {
    Modal.confirm({
      title: 'Želite li {0} automatsko obnavljanje oglasa za korisnika "{1}" ?'
        .replace(
          "{0}",
          userProfile.autoRenewal
            ? "deaktivirati"
            : "aktivirati"
        )
        .replace("{1}", userProfile.username),
      // @ts-ignore
      centered: true,
      iconType: "NaN",
      onOk() {
        props.autoRenewal(!userProfile.autoRenewal, userProfile.userId, success => {
          if (success) {
            setIsLoading(true);
            props.getUserProfileById(userProfile.userId).then(() => {
              setIsLoading(false);
              props.getUserStatistics(userProfile.userId);
            });
          }
        });
      }
    });
  };

  const handleXMLSyncNotificationsClick = (userProfile) => {
    Modal.confirm({
      title: 'Želite li {0} obavijesti o XML sinkronizaciji za korisnika "{1}" ?'
        .replace(
          "{0}",
          userProfile.receiveXMLSyncNotifications
            ? "deaktivirati"
            : "aktivirati"
        )
        .replace("{1}", userProfile.username),
      // @ts-ignore
      centered: true,
      iconType: "NaN",
      onOk() {
        props.activateXMLSyncNotifications(userProfile.userId, !userProfile.receiveXMLSyncNotifications, success => {
          if (success) {
            setIsLoading(true);
            props.getUserProfileById(userProfile.userId).then(() => {
              setIsLoading(false);
              props.getUserStatistics(userProfile.userId);
            });
          }
        });
      }
    });
  };

  const handleBlockClick = (user) => {
    const {
      unblockUser: handleUnblockUser,
      getUserProfileById,
    } = props;

    if (user.isBlocked) {
      Modal.confirm({
        title: `Želite li odblokirati ${user.username}?`,
        // @ts-ignore
        centered: true,
        iconType: "NaN",
        onOk() {
          handleUnblockUser(user.userId).then(() => {
            getUserProfileById(user.userId);
          }).catch(error => {
            console.error('Error updating user status:', error);
          });
        }
      });
      return;
    }

    setPendingBlock({ userId: user.userId, username: user.username });
  };

  const handleBlockCancel = () => {
    if (blockModalLoading) return;
    setPendingBlock(null);
  };

  const handleBlockConfirm = (reasonId: number, note: string, basedOn: number) => {
    if (!pendingBlock) return;
    const targetId = pendingBlock.userId;
    setBlockModalLoading(true);
    props.blockUser(targetId, reasonId, note, basedOn, null, (success) => {
      setBlockModalLoading(false);
      if (!success) return;
      setPendingBlock(null);
      props.getUserProfileById(targetId);
    });
  };

  const handleShadowBlockClick = (user) => {

    Modal.confirm({
      title: user.chatShadowBannedAt
        ? `Jeste li sigurni da želite poništiti shadow block za ${user.username}?`
        : `Jeste li sigurni da želite shadow blokirati ${user.username}?`,
      // @ts-ignore
      centered: true,
      iconType: "NaN",
      onOk() {
        props.triggerShadowBlock(user.userId, !Boolean(user.chatShadowBannedAt), (success) => {
          if (success) {
            setIsLoading(true);
            props.getUserProfileById(userProfile.userId).then(() => {
              setIsLoading(false);
              props.getUserStatistics(userProfile.userId);
            });
          }
        })
      }
    });
  };

  // DELETE USER
  const handleDeleteUser = (user) => {
    const {
      deleteUser: handleDeleteUser,
    } = props;

    Modal.confirm({
      title: 'Jeste li sigurni da želite trajno izbrisati korisnika  "{0}" ? Svi će podaci ovog korisnika biti uklonjeni i taj se postupak ne može poništiti.'
        .replace(
          "{0}",
          user.username
        ),
      // @ts-ignore
      centered: true,
      iconType: "NaN",
      onOk() {
        handleDeleteUser(user.userId)
          .then(() => {
            // Redirect to users page, after deleting the user
            history.push("/admin/user");
          }).catch(error => {
            console.error('Error deleting user:', error);
          });
      }
    });
  };

  const getUserData = (callback?) => {
    const { getUserProfile, user } = props;
    setTimeout(() => {
      getUserProfile(user, callback || null, true);
    }, 500);
  };


  const validateMaxLength = (maxLength, rule, value, callback) => {
    if (value && value[rule.field]) {
      const message = "Uneseni podaci ne smiju sadržavati više od  {0} znakova".replace(
        "{0}",
        maxLength
      );
      if (value[rule.field].length > maxLength) {
        callback(message);
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  const validateOib = async (rule, value, callback) => {
    const input = value && value[rule.field];

    if (!input || input.trim() === "") {
      return callback();
    }

    await isOibValid(input, callback);
  };


  const isOibValid = async (input: string, callback: (message?: string) => void) => {
    const value = input.toString();

    if (!/^\d{11}$/.test(value)) {
      return callback("OIB nije valjan.");
    }

    const oib = value.split('');
    let a = 10;

    for (let i = 0; i < 10; i++) {
      a += parseInt(oib[i], 10);
      a %= 10;
      if (a === 0) a = 10;
      a *= 2;
      a %= 11;
    }

    let control = 11 - a;
    if (control === 10) control = 0;

    if (control !== parseInt(oib[10], 10)) {
      return callback("OIB nije valjan.");
    }

    if (isAdminRoute) return callback();


    const result = await api.User.checkIdentityValue(value);
    if (result) {
      return callback("OIB je već u upotrebi.");
    }

    callback();
  }

  const validateUsername = async (rule, value, callback) => {
    const input = value && value[rule.field];

    if (!input || input.trim() === "") {
      return callback();
    }

    await isUsernameAvailable(input, callback);
  }

  const isUsernameAvailable = async (input: string, callback: (message?: string) => void) => {
    const value = input.toString();
    setSuggestedUsernames([]);

    // check if username has white spaces on the start or end only
    if (value.trim() !== value) {
      return callback("Korisničko ime ne može započeti ili završiti razmakom.");
    }

    // Check if the username length is valid
    if (!value || value.length < 3 || value.length > 30) {
      return callback("Korisničko ime mora imati između 3 i 30 znakova.");
    }

    // Check if the username contains only allowed characters
    if (/[#!?%:;[\]@!$&'()*+,\/=\\]/g.test(value)) {
      return callback("Korisničko ime sadrži nedozvoljene znakove.");
    }


    const result = await api.User.checkUsernameAvailability({
      username: value,
      userId: props.userProfile.userId,
    });

    // check if result is an array
    if (result && Array.isArray(result) && checkEmptyArray(result)) {
      setSuggestedUsernames(result);
      return callback("Ovo korisničko ime je zauzeto.");
    }

    callback();
  };

  const handleLegalEntityCheckbox = () => {
    setIsChecked((prev) => {
      if (prev === false) {
        setIsReceiptChecked(false)
      }
      if (!userProfile.isAgency || isAdminRoute) {
        return !prev
      }
    });
  };

  const handleReceiptChecked = () => {
    setIsReceiptChecked((prev) => !prev);
  };

  const handleObligorOfPublicProcurementChecked = () => {
    setIsObligor((prev) => !prev);
  };

  const handleAdminNotesClick = () => {
    setAdminNotesModalVisible(true);
  };

  const handleAdminNotesClose = () => {
    setAdminNotesModalVisible(false);
  }

  const validateUrl = async (rule, value, callback) => {
    const input = (value && value[rule.field]) || "";

    if (input.trim() === "") {
      return callback();
    }

    const urlRegex = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9][-a-zA-Z0-9]*(?:\.[a-zA-Z0-9][-a-zA-Z0-9]*)+(?:\/[^\s]*)?/gi;
    const urls = input.match(urlRegex);

    if (rule.field === "facebookUrl") {
      const facebookRegex = /^(?:https?:\/\/)?(?:www\.)?facebook\.com\/.+/i;
      if (!facebookRegex.test(input)) {
        return callback("Molimo, unesite ispravnu Facebook poveznicu");
      }
    }

    if (rule.field === "instagramUrl") {
      const instagramRegex = /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/.+/i;
      if (!instagramRegex.test(input)) {
        return callback("Molimo, unesite ispravnu Instagram poveznicu");
      }
    }

    return callback(urls ? undefined : "Molimo, unesite ispravan URL")
  }


  const renderUserProfile = () => {
    const {
      form,
      settings,
      userProfile,
      loading,
      isAdminRoute,
      match: {
        params: { id }
      }
    } = props;

    return (
      <React.Fragment>
        <div className="page-title">{"Moji podaci"}</div>
        <div className={styles.subContainer}>
          <Form onSubmit={handleSubmit}>
            <div className={`child-center ${styles.topSection} ${isAdminRoute ? styles.topSectionAdmin : ""}`}>
              <div className={styles.avatarWithName}>
                <Form.Item className={styles.formItem}>
                  {form.getFieldDecorator("avatar", {
                    initialValue: {
                      avatar: userProfile.avatar ? [userProfile.avatar] : []
                    }
                  })(
                    <PhotoUploader
                      field="avatar"
                      previewCardClassName={styles.avatar}
                      maxPhotoNumber={1}
                      uiComponent={SinglePhoto}
                      uploadClassName={styles.avatar}
                    />
                  )}
                </Form.Item>
                <div className={`child-center ${styles.name}`}>
                  {userProfile.firstName}
                </div>
              </div>
              {isAdminRoute ? (
                <UserStatistic
                  className={styles.statisticSection}
                  userProfile={userProfile}
                />
              ) : null}
            </div>

            <div className={styles.formItemContainer}>
              {/*
                // @ts-ignore */}
              <Row>
                <Col className={styles.formItemColumnLeft}  {...settings.responsiveProps.columnSpan}>
                  <div className={styles.sectionTitle}>
                    {"Informacije računa"}
                  </div>
                  {userProfile.isBlocked && (
                    <div style={{ color: "white", background: "red", fontWeight: "bold", padding: 5, marginBottom: 10, fontSize: 16 }}>
                      Korisnik je blokiran
                    </div>
                  )}
                  {userProfile.chatShadowBannedAt && (
                    <div style={{ color: "white", background: "red", fontWeight: "bold", padding: 5, marginBottom: 10, fontSize: 16 }}>
                      Korisnik je shadow blokiran
                    </div>
                  )}
                  <FormInputText
                    key={"username" + suggestedUsername}
                    field="username"
                    title={"Korisničko ime"}
                    isRequired={true}
                    validationText={"Molimo, unesite Vaše Korisničko ime"}
                    validator={validateUsername}
                    inputTextProps={{
                      isDisabled: isAdminRoute
                        ? !isAdminRoute
                        : !userProfile.canUpdateUsername,
                      placeholder: settings.placeholder.username,
                      valueType: InputType.string
                    }}
                    shouldShowValue={!userProfile.isTempUsername}
                    form={form}
                    userProfile={userProfile}
                  />

                  {!userProfile.canUpdateUsername && (
                    <div className={styles.usernameInfo}>
                      Korisničko ime možete mijenjati jednom u 10 dana. Pokušajte kasnije.
                    </div>
                  )}

                  {suggestedUsernames.length > 0 && (
                    <div className={styles.suggestedUsernames}>
                      <div className={styles.title}>
                        Slobodna korisnička imena:
                      </div>

                      {suggestedUsernames.map((suggestion) => (
                        <div
                          key={suggestion}
                          onClick={() => {
                            form.setFields({
                              username: {
                                value: { username: suggestion },
                                touched: true,
                                validating: true
                              }
                            });

                            setIsDirty(true);
                            setIsValidating(true);

                            form.validateFields(["username"], (errors) => {
                              if (!errors) {
                                setIsDirty(false);
                                setIsValidating(false);
                                setSuggestedUsernames([]);
                                setSuggestedUsername(suggestion);
                              }
                            });
                          }}
                          className={styles.username}
                        >
                          {suggestion}
                        </div>
                      ))}
                    </div>
                  )}
                  <FormInputText
                    field="email"
                    title={"E-mail adresa"}
                    isRequired={true}
                    validator={validateMaxLength.bind(
                      this,
                      settings.formValidation.emailMaxLength
                    )}
                    inputTextProps={{
                      isDisabled: isAdminRoute
                        ? !isAdminRoute
                        : userProfile.email,
                      placeholder: settings.placeholder.email,
                      valueType: InputType.string
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  <FormInputText
                    field="firstName"
                    title={"Ime"}
                    isRequired={true}
                    validationText={"Molimo, unesite Vaše Ime"}
                    validator={validateMaxLength.bind(
                      this,
                      settings.formValidation.firstNameMaxLength
                    )}
                    inputTextProps={{
                      placeholder: settings.placeholder.firstName,
                      valueType: InputType.string
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  <FormInputText
                    field="lastName"
                    title={"Prezime"}
                    isRequired={true}
                    validationText={"Molimo, unesite Vaše Prezime"}
                    validator={validateMaxLength.bind(
                      this,
                      settings.formValidation.lastNameMaxLength
                    )}
                    inputTextProps={{
                      placeholder: settings.placeholder.lastName,
                      valueType: InputType.string
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  <Form.Item className={styles.formItem}>
                    {form.getFieldDecorator("dateOfBirth", {
                      initialValue: !userProfile.dateOfBirth
                        ? undefined
                        : {
                          dateOfBirth: userProfile.dateOfBirth
                        }
                    })(
                      <DateSelector
                        field="dateOfBirth"
                        controlType={InputType.date}
                        title={"Datum rođenja"}
                        placeholder={settings.placeholder.dateOfBirth}
                        max={today}
                        customDisabledDates={false}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col className={styles.formItemColumnRight} {...settings.responsiveProps.columnSpan}>
                  <div className={styles.sectionTitle}>
                    {"Adresa"}
                  </div>
                  <Form.Item className={styles.formItem}>
                    {form.getFieldDecorator(DataSource.location, {
                      initialValue: !userProfile.countryId
                        ? undefined
                        : {
                          countryId: userProfile.countryId,
                          cityId: userProfile.cityId,
                          countyId: userProfile.countyId,
                          settlementId: userProfile.settlementId
                        },
                      rules: [locationValidator]
                    })(
                      <MultiLevelSelector
                        title="location"
                        {...settings.location}
                        selectorClassName={styles.selector}
                        className={styles.multiLevelSelector}
                        onError={error => {
                          errors.location = error;
                        }}
                      />
                    )}
                  </Form.Item>
                  <FormInputText
                    field="zipCode"
                    title={"Poštanski broj "}
                    isRequired={true}
                    validationText={"Molimo, unesite Vaš Poštanski broj"}
                    inputTextProps={{
                      placeholder: settings.placeholder.zipCode
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  <FormInputText
                    field="street"
                    title={"Ulica"}
                    isRequired={true}
                    validationText={"Molimo, unesite Vašu Ulicu"}
                    validator={validateMaxLength.bind(
                      this,
                      settings.formValidation.streetMaxLength
                    )}
                    inputTextProps={{
                      placeholder: settings.placeholder.street,
                      valueType: InputType.string
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  <FormInputText
                    field="houseNumber"
                    title={"Kućni broj"}
                    isRequired={false}
                    validator={validateMaxLength.bind(
                      this,
                      settings.formValidation.houseMaxLength
                    )}
                    inputTextProps={{
                      placeholder: settings.placeholder.houseNumber
                    }}
                    form={form}
                    userProfile={userProfile}
                  />
                  {isAdminRoute && (
                    <Form.Item className={styles.formItem}>
                      {form.getFieldDecorator("isIdentityNumberRequiredOverride", {
                        valuePropName: "checked",
                        initialValue: userProfile.isIdentityNumberRequired
                      })(
                        <Checkbox>
                          {"Obavezan OIB"}
                        </Checkbox>
                      )}
                    </Form.Item>
                  )}

                  {form.getFieldValue("location") && form.getFieldValue("location").countryId === HrCountryId &&
                    <FormInputText
                      field="identityNumber"
                      title={
                        <React.Fragment>
                          {"OIB"}
                          <Popover
                            trigger="click"
                            content={
                              <pre className={styles.oibInfo}>
                                <StaticHTML content={"Prikupljamo OIB kako bismo uskladili poslovanje sa {0} te osigurali registraciju jedinstvenih korisnika, čime povećavamo sigurnost i zaštitu korisnika na Index Oglasima. Vaš OIB koristimo isključivo u ovu svrhu i ni u kojem ga slučaju ne upotrebljavamo za druge namjene, pri čemu se strogo pridržavamo propisa o zaštiti podataka."
                                  .replace("{0}", "<a href='https://www.zakon.hr/z/472/Zakon-o-zabrani-i-sprje%C4%8Davanju-obavljanja-neregistrirane-djelatnosti' target='_blank'><b>" + "Zakonom o zabrani i sprječavanju obavljanja neregistrirane djelatnosti" + "</b></a>")}
                                />

                                {"Korisnik Oglasnika nije obavezan unijeti svoj OIB u korisnički račun. Međutim, bez unosa OIB-a neće moći koristiti sve funkcionalnosti Oglasnika u punom opsegu."}
                              </pre>
                            }
                          >
                            <Icon
                              className={styles.infoIcon}
                              type="info-circle-o"
                            />
                          </Popover>
                        </React.Fragment>
                      }
                      isRequired={isIdentityNumberRequired}
                      validationText={isIdentityNumberRequired ? "Molimo, unesite Vaš OIB." : null}
                      validator={validateOib}
                      inputTextProps={{
                        placeholder: settings.placeholder.identityNumber
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                  }

                  <Form.Item className={styles.formItem}>
                    {form.getFieldDecorator("legalEntity", {
                      valuePropName: "checked",
                      initialValue: userProfile.legalEntity

                    })(
                      <Checkbox onChange={handleLegalEntityCheckbox}
                        disabled={isAdminRoute || !userProfile.isAgency ? false : true}
                      >
                        <React.Fragment>
                          {"Pravna osoba"}
                          {!isAdminRoute && userProfile.isAgency &&
                            <Popover
                              trigger="click"
                              content={
                                <p className={styles.infoText}>
                                  {"Ovu opciju nije moguće samostalno promijeniti. Ako ipak trebate promijeniti status, obratite se korisničkoj podršci."}
                                </p>
                              }
                            >
                              <Icon
                                className={styles.infoIcon}
                                type="info-circle-o"
                              />
                            </Popover>
                          }

                        </React.Fragment>
                      </Checkbox>
                    )}
                  </Form.Item>

                  {isChecked &&
                    <FormInputText
                      field="legalEntityIdentifier"
                      title={"OIB"}
                      isRequired={false}
                      inputTextProps={{
                        placeholder: settings.placeholder.legalEntityIdentifier
                      }}
                      form={form}
                      userProfile={userProfile}
                    />}


                  {isChecked && (
                    <Form.Item className={styles.formItem}>
                      {form.getFieldDecorator("description", {
                        initialValue: !userProfile.description
                          ? undefined
                          : { description: userProfile.description },
                        rules: [
                          validateMaxLength.bind(
                            this,
                            settings.formValidation.descriptionMaxLength
                          )
                        ]
                      })(
                        <InputText
                          valueType={InputType.text}
                          placeholder={settings.placeholder.description}
                          field="description"
                          title={
                            <React.Fragment>
                              {"Opis"}
                              <Popover
                                trigger="click"
                                content={

                                  <pre className={styles.oibInfo}>
                                    <StaticHTML content={"U ovo polje unosite kratko objašnjenje svoje trgovine ili obrta, npr. čime se bavite, koje proizvode nudite ili koja je vaša specijalnost. Tekst koji ovdje unesete prikazuje se na vašoj stranici sa svim vašim oglasima."}
                                    />
                                  </pre>
                                }
                              >
                                <Icon
                                  className={styles.infoIcon}
                                  type="info-circle-o"
                                />
                              </Popover>
                            </React.Fragment>
                          }
                        />
                      )}
                    </Form.Item>
                  )}

                  {isChecked &&
                    <div className={styles.sectionSubTitle}>
                      Radno Vrijeme
                    </div>
                  }

                  {isChecked &&
                    <FormInputText
                      field="workingHoursWorkingDay"
                      title="Radni dan"
                      isRequired={false}
                      validator={validateMaxLength.bind(
                        this,
                        50
                      )}
                      inputTextProps={{
                        placeholder: "Npr. 08h - 16h",
                        valueType: InputType.string
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                  }
                  {isChecked &&
                    <FormInputText
                      field="workingHoursSaturday"
                      title="Subota"
                      isRequired={false}
                      validator={validateMaxLength.bind(
                        this,
                        50
                      )}
                      inputTextProps={{
                        placeholder: "Npr. 08h - 12h ili neradno",
                        valueType: InputType.string
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                  }
                  {isChecked &&
                    <FormInputText
                      field="workingHoursSunday"
                      title="Nedjelja"
                      isRequired={false}
                      validator={validateMaxLength.bind(
                        this,
                        50
                      )}
                      inputTextProps={{
                        placeholder: "Npr. 08h - 12h ili neradno",
                        valueType: InputType.string
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                  }

                  {isChecked && (
                    <React.Fragment>
                      <div className={styles.sectionSubTitle}>
                        Vaše poveznice
                      </div>

                      <FormInputText
                        field="websiteUrl"
                        title="Web"
                        isRequired={false}
                        validationText={"Molimo, unesite ispravan URL"}
                        validator={validateUrl}
                        inputTextProps={{
                          placeholder: settings.placeholder.websiteUrl,
                          valueType: InputType.string
                        }}
                        form={form}
                        userProfile={userProfile}
                      />
                      <FormInputText
                        field="facebookUrl"
                        title="Facebook"
                        isRequired={false}
                        validationText={"Molimo, unesite ispravan URL"}
                        validator={validateUrl}
                        inputTextProps={{
                          placeholder: settings.placeholder.facebookUrl,
                          valueType: InputType.string
                        }}
                        form={form}
                        userProfile={userProfile}
                      />
                      <FormInputText
                        field="instagramUrl"
                        title="Instagram"
                        isRequired={false}
                        validationText={"Molimo, unesite ispravan URL"}
                        validator={validateUrl}
                        inputTextProps={{
                          placeholder: settings.placeholder.instagramUrl,
                          valueType: InputType.string
                        }}
                        form={form}
                        userProfile={userProfile}
                      />
                    </React.Fragment>
                  )}


                  {
                    isChecked && (
                      <Form.Item className={styles.formItem}>
                        {form.getFieldDecorator("isUsingVATInvoice", {
                          valuePropName: "checked",
                          initialValue: isReceipt !== null ? isReceipt : userProfile.isUsingVATInvoice
                        })(
                          <Checkbox onChange={handleReceiptChecked}>
                            {"Želiš primati R1 račun?"}
                          </Checkbox>
                        )}
                      </Form.Item>
                    )
                  }

                </Col>
              </Row>
            </div >


            {/* R1 receipt inputs */}
            {isReceipt && isChecked && countries && (
              <div className={`${styles.receiptContainter} ${styles.formItemContainer}`}>
                <div className={styles.sectionTitle}>
                  {"Podaci za R1 račun"}
                </div>
                <Row>
                  <Col className={styles.formItemColumnLeft}  {...settings.responsiveProps.columnSpan}>
                    <Form.Item className={styles.formItem}>
                      {form.getFieldDecorator("vatInvoiceCountryId", {
                        initialValue: { vatInvoiceCountryId: userProfile.vatInvoiceCountryId ? userProfile.vatInvoiceCountryId : HrCountryId },
                        rules: [
                          {
                            required: true,
                            message: settings.placeholder.vatCountry,
                          }
                        ]
                      })(
                        <DropdownSelect
                          field="vatInvoiceCountryId"
                          title={"Država"}
                          isRequired={true}
                          placeholder={settings.placeholder.vatCountry}
                          options={countries.map((country) => ({
                            title: country.name,
                            value: country.id
                          }))}
                          onChange={(value) => {
                            form.setFieldsValue({ vatInvoiceCountryId: value });
                          }}
                        />
                      )}
                    </Form.Item>

                    {/* OIB OR VAT */}
                    {form.getFieldValue("vatInvoiceCountryId") && form.getFieldValue("vatInvoiceCountryId").vatInvoiceCountryId === HrCountryId &&
                      <FormInputText
                        field="vatid"
                        title={"OIB"}
                        isRequired={true}
                        validationText={"Molimo, unesite Vaš OIB."}
                        validator={validateOib}
                        inputTextProps={{
                          placeholder: settings.placeholder.identityNumber
                        }}
                        form={form}
                        userProfile={userProfile}
                      /> || <FormInputText
                        field="vatid"
                        title={"VAT ID"}
                        isRequired={true}
                        validationText={"Molimo, unesite Vaš VAT."}
                        inputTextProps={{
                          placeholder: settings.placeholder.vatIdentityNumber
                        }}
                        form={form}
                        userProfile={userProfile}
                      />
                    }

                    <FormInputText
                      field="vatInvoiceLegalEntityName"
                      title={"Naziv pravnog subjekta"}
                      isRequired={true}
                      validationText={"Molimo, unesite naziv pravnog subjekta"}
                      inputTextProps={{
                        placeholder: settings.placeholder.legalEntityName
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                    <FormInputText
                      field="vatInvoiceStreet"
                      title={"Ulica"}
                      isRequired={true}
                      validationText={"Molimo, unesite Vašu Ulicu"}
                      validator={validateMaxLength.bind(
                        this,
                        settings.formValidation.streetMaxLength
                      )}
                      inputTextProps={{
                        placeholder: settings.placeholder.street,
                        valueType: InputType.string
                      }}
                      form={form}
                      userProfile={userProfile}
                    />



                  </Col>

                  <Col className={styles.formItemColumnRight} {...settings.responsiveProps.columnSpan}>
                    <FormInputText
                      field="vatInvoiceHouseNumber"
                      title={"Kućni broj"}
                      isRequired={true}
                      validationText={"Molimo, unesite Vaš Kućni broj"}
                      validator={validateMaxLength.bind(
                        this,
                        settings.formValidation.houseMaxLength
                      )}
                      inputTextProps={{
                        placeholder: settings.placeholder.houseNumber
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                    <FormInputText
                      field="vatInvoicePlace"
                      title={"Mjesto"}
                      isRequired={true}
                      validationText={"Molimo, unesite Vaše Mjesto"}
                      validator={validateMaxLength.bind(
                        this,
                        settings.formValidation.placeMaxLength
                      )}
                      inputTextProps={{
                        placeholder: settings.placeholder.place
                      }}
                      form={form}
                      userProfile={userProfile}
                    />
                    <FormInputText
                      field="vatInvoiceZipCode"
                      title={"Poštanski broj "}
                      isRequired={true}
                      validationText={"Molimo, unesite Vaš Poštanski broj"}
                      inputTextProps={{
                        placeholder: settings.placeholder.zipCode
                      }}
                      form={form}
                      userProfile={userProfile}
                    />

                    {/* isObligor */}
                    {form.getFieldValue("vatInvoiceCountryId") && form.getFieldValue("vatInvoiceCountryId").vatInvoiceCountryId === HrCountryId &&
                      <Form.Item className={styles.formItem}>
                        {form.getFieldDecorator("isPublicProcurement", {
                          valuePropName: "checked",
                          initialValue: userProfile.isPublicProcurement
                        })(
                          <Checkbox onChange={handleObligorOfPublicProcurementChecked}>
                            {"Obveznik javne nabave"}
                          </Checkbox>
                        )}
                      </Form.Item>
                    }
                  </Col>
                </Row>



              </div>
            )
            }

            <div className={`${styles.formItemContainer} ${styles.phonesContainer}`}>
              <div className={styles.sectionTitle}>
                {" Telefonski brojevi"}
              </div>
              <PhoneNumbers
                ref={phoneNumbersRef}
                isFormPage={false}
                userProfile={userProfile}
                isEntityChecked={isChecked}
                isAdminRoute={isAdminRoute}
                adminUserId={id}
              />
            </div >

            <div className={styles.submitBtnContainer}>
              {isAdminRoute && props.user.role === UserRole.superAdmin ? (
                <React.Fragment>
                  <Button className={styles.submitBtn}
                    type="default"
                    onClick={() => handleAdminNotesClick()}
                  >
                    {"Bilješke"}
                  </Button>
                  <AdminNotes
                    show={adminNotesModalVisible}
                    entityId={userProfile.userId}
                    entityName={userProfile.username}
                    onClose={handleAdminNotesClose}
                  />
                </React.Fragment>) : null}
              <Button
                htmlType="submit"
                type="primary"
                className={styles.submitBtn}
                loading={loading}
                disabled={!form.isFieldsTouched()}
              >
                {"Spremi promjene"}
              </Button>
              {isAdminRoute ? (
                <DominantCategoriesModal
                  userId={id}
                  initialDominantCategories={userProfile.dominantCategories}
                  buttonClassName={styles.submitBtn}
                />
              ) : null}
              {isAdminRoute ? (
                <Button
                  className={styles.submitBtn}
                  onClick={() => {
                    props.sendActivationEmail(id);
                  }}
                >
                  {"Ponovno pošalji aktivaciju"}
                </Button>
              ) : null}
              {isAdminRoute && userProfile.isAgency ? (
                <Button
                  type={userProfile.receiveXMLSyncNotifications ? "default" : "primary"}
                  className={styles.submitBtn}
                  onClick={() => {
                    handleXMLSyncNotificationsClick(userProfile);
                  }}
                >
                  {userProfile.receiveXMLSyncNotifications ? "Deaktiviraj obavijesti o XML sinkronizaciji" : "Aktiviraj obavijesti o XML sinkronizaciji"}
                </Button>
              ) : null}
              {isAdminRoute ? (
                <Button
                  className={styles.submitBtn}
                  type={userProfile.autoRenewal ? "default" : "primary"}
                  onClick={() => handleAutoRenewalClick(userProfile)}
                //disabled={!userProfile.eligibleForAutoRenewal} // Prop is not available in the current API response
                >
                  {userProfile.autoRenewal
                    ? "Deaktiviraj automatsku obnovu"
                    : "Aktiviraj automatsku obnovu"}
                </Button>
              ) : null}
              {isAdminRoute ? (
                <Button className={styles.submitBtn}
                  type="primary"
                  onClick={() => handleBlockClick(userProfile)}>
                  {userProfile.isBlocked
                    ? "Odblokiraj"
                    : "Blokiraj"}
                </Button>) : null}
              {isAdminRoute ? (
                <Button className={styles.submitBtn}
                  type="primary"
                  onClick={() => handleShadowBlockClick(userProfile)}>
                  {userProfile.chatShadowBannedAt
                    ? "Poništi Shadow Block"
                    : "Shadow blokiraj"}
                </Button>) : null}
              {isAdminRoute && props.user.role === UserRole.superAdmin ? (
                <Button className={styles.submitBtn}
                  type="primary"
                  onClick={() => handleDeleteUser(userProfile)}>
                  {"Obriši"}
                </Button>) : null}
              <div className="clearing" />
            </div>
          </Form>
        </div>
        <ReasonPickerModal
          visible={!!pendingBlock}
          title={
            pendingBlock && pendingBlock.username
              ? `Blokiraj korisnika ${pendingBlock.username}`
              : "Blokiraj korisnika"
          }
          reasons={props.blockReasons || []}
          submitText="Blokiraj"
          loading={blockModalLoading}
          onCancel={handleBlockCancel}
          onConfirm={handleBlockConfirm}
        />
      </React.Fragment>
    );
  };

  if (!isAdminRoute) {
    return (
      <LeftMenu activeKey={path}>
        <HelmetComponent
          title={`${"Moji podaci"} | ${"INDEX OGLASI"}`}
          index={false}
        />

        <React.Fragment>
          {renderUserProfile()}
        </React.Fragment>

        <VerifyModal
          visible={showPhoneVerifyModal}
          heading="Obavijest"
          content={"Vaše promjene su uspješno spremljene.\n\nZa slanje poruka i objavu oglasa potrebno je verificirati barem jedan broj telefona. Verificirajte broj kako biste mogli koristiti sve funkcionalnosti.\n\nŽelite li to učiniti sada?"}
          okText="Želim"
          cancelText="Odustani"
          onOk={() => {
            setShowPhoneVerifyModal(false);
            const phoneSection = document.querySelector(`.${styles.phonesContainer}`);
            if (phoneSection) {
              phoneSection.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            setTimeout(() => {
              if (phoneNumbersRef.current) {
                phoneNumbersRef.current.addAndFocusNewPhone();
              }
            }, 500);
          }}
          onCancel={() => setShowPhoneVerifyModal(false)}
          closable={false}
          className={appStyles.modal}
        />
      </LeftMenu>
    );
  }

  return isLoading ? (
    <Loading />
  ) : (
    renderUserProfile()
  );
};

UserProfilePage.defaultProps = {
  settings: defaultSettings,
  loading: false,
  isAdminRoute: false
};

const ConnectedUserProfilePage = connect(
  (state, props) => ({
    userProfile: selectUser(state, props),
    countries: selectCountries(state),
    blockReasons: selectBlockReasons(state),
  }),
  {
    getUserProfileById,
    getUserStatistics,
    sendActivationEmail,
    activateXMLSyncNotifications,
    getUserProfile,
    blockUser,
    unblockUser,
    getBlockReasons,
    deleteUser,
    autoRenewal,
    triggerShadowBlock,
  }
  // @ts-ignore
)(Form.create()(UserProfilePage));

export default requireUserLogin(
  submitFormData(withSize()(ConnectedUserProfilePage), updateUserProfile)
);



// WEBPACK FOOTER //
// ./src/containers/UserProfilePage/index.tsx